import { ITag } from '../Tags/tags.models';

export interface ISearch {
  title?: string;
  elements: JSX.Element[];
  tags?: ITag[];
  toggleTags?: (tag: ITag) => void;
  onClickElement?: (indexElement: number) => void;
  onIncrementSearch?: () => void;
}

export enum Increment {
  'MOBILE' = 1,
  'TABLET' = 2,
  'DESKTOP' = 4,
}

export enum DefaultMax {
  'MOBILE' = 6,
  'TABLET' = 8,
  'DESKTOP' = 12,
}
